"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseBtn = void 0;
var react_1 = __importDefault(require("react"));
var CloseBtn_style_1 = __importDefault(require("./CloseBtn.style"));
exports.CloseBtn = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, color = _a.color, onClick = _a.onClick;
    return (react_1.default.createElement("span", { "data-testid": "close-btn", onClick: onClick },
        react_1.default.createElement(CloseBtn_style_1.default, { color: color, size: size })));
};
//# sourceMappingURL=CloseBtn.js.map